import styled from "styled-components";

const InputPseudo = styled.input`
  background-color: #4e4643;
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  font-size: 2em;
  font-weight: bold;
  width: 98%;
  cursor: default;
`;

export default InputPseudo;
